export default __webpack_public_path__ + "static/media/logo-small.1f194eef.svg";